import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
export const AnalyticsQuickViewFavoriteToggle = ({ favorited, onClick, }) => {
    return (_jsx(IconButton, { variant: "tertiary", icon: favorited ? 'star-full' : 'star', iconProps: {
            color: favorited ? colors.orange[300] : colors.neutral[400],
        }, onClick: onClick }));
};
